(function () {

    'use strict';

    fsZipDownloadConfirmDialog.$inject = [];

    function fsZipDownloadConfirmDialog() {
        return {
            restrict: 'A',
            scope: {
                title: '@',
                okButtonText: '@',
                okCallback: '&'
            },
            template: require('./fs-zip-download-confirm-dialog.html'),
            link: function (scope) {
                scope.downloadZip = function () {
                    scope.$parent.$broadcast('zip-download');
                }

                scope.$on('zip-download-confirm-dialog', function (event, args) {
                    scope.numberOfZipFiles = args.numberOfZipFiles;
                    scope.$broadcast('show-confirm-dialog');
                });
            }
        }
    }

    module.exports = fsZipDownloadConfirmDialog;
})();